const prodUrl = 'https://crm.zhaopeiyun.com/'
const localDevUrl = 'http://localhost:5000/'
const serviceZpcAdminDev = 'http://service.91qpzs.com:6601/'
const localServiceZpcAdminDev = 'http://192.168.0.32:6601/'
const itemSourceEffectTime = '2026-09-15 19:00:00'
var baseURL = process.env.NODE_ENV === 'development' ? localDevUrl : prodUrl
export default {
  baseURL,
  tokenType: 'bearer',
  tokenName: 'accessToken',
  localTokenName: '_zpcCrm',
  expireAtProp: 'expireAt',
  itemSourceEffectTime,
  serviceZpcAdminDev: process.env.NODE_ENV === 'development' ? localServiceZpcAdminDev : serviceZpcAdminDev
}
